module.exports = __webpack_public_path__ + "static/media/waisttraner.4a4baaa6.jpg";